// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'

const FilterInputAndSubmit = ({ idRoot }) => ([
  <Field
    key={'filter-input'}
    component={'input'}
    id={`${idRoot}-input`}
    label={''}
    name={'filterInput'}
    placeholder={'Path Filter'}
    type={'text'} />,
  <button
    key={'filter-submit'}
    className={'search-button'}
    id={`${idRoot}-apply`}
    type={'submit'} />,
])

FilterInputAndSubmit.propTypes = {
  idRoot: string.isRequired,
}

export default FilterInputAndSubmit
